export default "__VITE_ASSET__DEBVKpep__"